<template>
  <div class="health">
    <div class="status">OK</div>
    <div class="message">Service is healthy</div>
    <div class="timestamp">{{ currentTime }}</div>
  </div>
</template>

<script>
export default {
  name: 'Health',
  data() {
    return {
      currentTime: new Date().toISOString()
    }
  }
}
</script>

<style scoped>
.health {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background: #f5f5f5;
}

.status {
  font-size: 48px;
  font-weight: bold;
  color: #52c41a;
  margin-bottom: 16px;
}

.message {
  font-size: 18px;
  color: #666;
  margin-bottom: 16px;
}

.timestamp {
  font-size: 14px;
  color: #999;
}
</style>
